import {
  CandidateActivitySelect,
  // CandidateActivitySelect,
  CandidateEmploymentTypesSelect,
  CandidateScheduleWorksSelect,
} from '@widgets/candidate';
import { Flex } from '@mantine/core';
import { useForm } from '@mantine/form';
import { FiltersBlock, FormTextField } from '@shared/ui';
import { DEFAULT_RESUME_FILTER_FORM_VALUES } from '../constants';
import type { CandidateResumeFilterFormValues } from '../types';

type CandidateResumeListFiltersProps = {
  onApply: (values: CandidateResumeFilterFormValues) => void;
  onReset: () => void;
};

export const CandidateResumeListFilters = ({
  onApply,
  onReset,
}: CandidateResumeListFiltersProps) => {
  const form = useForm<CandidateResumeFilterFormValues>({
    initialValues: DEFAULT_RESUME_FILTER_FORM_VALUES,
  });

  const handleReset = () => {
    form.reset();
    onReset();
  };

  return (
    <FiltersBlock onSubmit={form.onSubmit(onApply)} onReset={handleReset}>
      <Flex wrap='wrap' direction='row' gap={16} w='100%' maw={1070}>
        <FormTextField
          variant='column'
          title='Желаемая работа'
          description=''
          aria-label='Желаемая работа'
          placeholder='Введите должность'
          {...form.getInputProps('desiredJob')}
          containerProps={{ gap: 4, flex: 1 }}
        />
        <CandidateEmploymentTypesSelect
          {...form.getInputProps('employmentTypeId')}
        />
        <CandidateScheduleWorksSelect
          {...form.getInputProps('scheduleWorkId')}
        />
        <CandidateActivitySelect {...form.getInputProps('isActive')} />
      </Flex>
    </FiltersBlock>
  );
};
